import { useEffect, useState } from "react";
import { resolveRfidImageUrl } from "./rfidImageUtils";

const RfidImage = ({
  imageUrl,
  file = null,
  alt = "RFID",
  style,
  className,
  fallback = null,
  onClick,
}) => {
  const [src, setSrc] = useState("");
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    let objectUrl = null;

    setStatus("loading");
    setSrc("");

    if (file instanceof File) {
      objectUrl = URL.createObjectURL(file);
      setSrc(objectUrl);
      setStatus("ready");
    } else {
      const resolved = resolveRfidImageUrl(imageUrl);
      if (!resolved) {
        setStatus("failed");
      } else {
        setSrc(resolved);
        setStatus("ready");
      }
    }

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [imageUrl, file]);

  if (status === "loading") return null;
  if (status === "failed" || !src) return fallback;

  return (
    <img
      src={src}
      alt={alt}
      style={style}
      className={className}
      onClick={onClick}
      onError={() => setStatus("failed")}
    />
  );
};

export default RfidImage;